import { ReactNode, useState } from "react";
import DomainFinderModal from "./DomainFinderModal";
import Context from "./context";

export { useDomainFinder } from "./hooks";

export default function DomainFinder({
  children,
  initialIsOpen = false,
}: {
  children?: ReactNode;
  initialIsOpen?: boolean;
}) {
  const value = useState(initialIsOpen);
  const [isOpen, setIsOpen] = value;

  return (
    <Context.Provider value={value}>
      {children}
      <DomainFinderModal open={isOpen} onClose={() => setIsOpen(false)} />
    </Context.Provider>
  );
}
